import { createContext, useContext, useState, useEffect, useMemo, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LangContext = createContext();

const LANGS = [
  { code: "en", label: "EN", name: "English" },
  { code: "az", label: "AZ", name: "Azərbaycanca" },
  { code: "tr", label: "TR", name: "Türkçe" },
  { code: "ru", label: "RU", name: "Русский" },
];

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("gaca_lang") || "en");
  const [t, setT] = useState(null);

  const setLang = useCallback((newLang) => {
    setLangState(newLang);
  }, [setLangState]);

  useEffect(() => {
    localStorage.setItem("gaca_lang", lang);
    axios.get(`${API}/translations/${lang}`).then((res) => setT(res.data)).catch(() => {});
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t, LANGS }), [lang, setLang, t]);

  return (
    <LangContext.Provider value={value}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
